import { useQuery } from "@tanstack/react-query";
import { endpoints } from "../endpoints/endpoints";
import axiosInstance from "../utilites/axios";
import moment from "moment-timezone";
// limit=${limit * 3}
export const useGetRepairingList = ({ limit }) => {
  return useQuery({
    queryKey: ["repairingList", limit],
    queryFn: async () => {
      return await axiosInstance
        .get(
          `${endpoints.repairing}?date=${moment()
            .tz("America/New_York")
            .format("yyyy-MM-DD")}&limit=100`
        )
        .then((res) => {
          if (res?.status === 200) {
            return res?.data;
          } else {
            return [];
          }
        })
        .catch((e) => {
          // console.log("error", e);
        });
    },
    refetchInterval: 500 * 10,
    onSuccess: ({ data }) => {
      return data;
    },
  });
};

export const useGetRepairingingDetails = ({ uid }) => {
  return useQuery({
    queryKey: ["repairingDetails", uid],
    queryFn: async () => {
      return await axiosInstance
        .get(
          `${endpoints.repairing}/details?uid=${uid}&date=${moment()
            .tz("America/New_York")
            .format("yyyy-MM-DD")}`
        )
        .then((res) => {
          if (res?.status === 200) {
            return res?.data;
          } else {
            return [];
          }
        })
        .catch((e) => {
          // console.log(e);
        });
    },
    refetchInterval: 500 * 10,
    onSuccess: ({ data }) => {
      return data;
    },
  });
};
